import React, { useState, useEffect } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Helmet } from "react-helmet";

import {
  Link,
  useLocation,
  useHistory,
  useParams,
  Switch,
  Route,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth_actions } from "../../../redux-store";
import { show_for } from "../../../utils";
import clsx from "clsx";
import ReactGa from "react-ga";

import {
  AccountInfo,
  AddressBook,
  ChangePassword,
  Earnings,
  Orders,
  Products,
  CreateProduct,
} from "./components";
import OrdersMer from "./components/OrdersMer";
import addGreeting from "./components/addGreeting";
import changePaymentMethod from "./components/changePaymentMethod";
import AddCharges from "./components/AddCharges";
import Contact from "../contact";
import ChangeCredentials from "./components/ChangeCredentials";
import MyContacts from "./components/MyContacts";
import AccountMember from "./components/AccountMember";
import AvailableEac from "./components/AvailableEac";
import Available from "../Available";
import AccountHistory from "./components/AccountHistory";
import MemberPurchases from "./components/MemberPurchases";
import MyAds from "./components/AdWorkShop/MyAds";
import AccountBrand from "./components/AccountBrand";
// import {OrdersMer} from "./components";
const Dashboard = (props) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { role } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (["customer", "member", "merchant", "brand"].every((i) => i !== role)) {
      history.replace(`${process.env.PUBLIC_URL}/`);
      console.log("error is here")
    }
    ReactGa.initialize("UA-205848017-1");
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div>
      {/* <Helmet> 
        <title>eksplode! | Dashboard </title>
      </Helmet>*/}
      <Breadcrumb title={"Dashboard"} />
      {/*Dashboard section*/}
      <section className="section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              {/* <div className='account-sidebar'>
                <a className='popup-btn'>My account</a>
              </div> */}
              <div className="dashboard-left">
                <div className="collection-mobile-back">
                  <span className="filter-back">
                    <i className="fa fa-angle-left" aria-hidden="true" /> back
                  </span>
                </div>
                <div className="block-content">
                  <ul>
                    {role === "member" && (
                      <>
                        <li
                          className={clsx({
                            // active: pathname.includes('account-history'),
                            active: pathname.includes("earning"),
                          })}
                        >
                          <Link
                            // to={`${process.env.PUBLIC_URL}/dashboard/${role}/account-history`}
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/earning`}
                          >
                            {/* View My Account History */}
                            My Earnings
                          </Link>
                        </li>

                        <li
                          className={clsx({
                            active: pathname.endsWith("account"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/account`}
                          >
                            View My Eksplode code
                          </Link>
                        </li>

                        <li
                          className={clsx({
                            active: pathname.endsWith("products"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/products`}
                          >
                            View My EACs
                          </Link>
                        </li>

                        <li
                          className={clsx({
                            active: pathname.endsWith("my-contacts"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/my-contacts`}
                          >
                            View My Contact List
                          </Link>
                        </li>

                        <li
                          className={clsx({
                            active: pathname.endsWith("availableeac"),
                          })}
                        >
                          <Link to={`${process.env.PUBLIC_URL}/availableeac`}>
                            View Available EACs
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("greeting"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/greeting`}
                          >
                            Customize My EAC Greeting
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("purchases"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/purchases`}
                          >
                            My Purchases
                          </Link>
                        </li>
                      </>
                    )}
                    {role === "merchant" && (
                      <>
                        <li
                          className={clsx({
                            active: pathname.endsWith("/dashboard/merchant"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/merchant`}
                          >
                            My Account
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("products"),
                          })}
                        >
                          <Link to={`${process.env.PUBLIC_URL}/shop`}>
                            My Products
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("create-product"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/create-product`}
                          >
                            Create Product
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("add-charges"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/add-charges`}
                          >
                            Delivery Charges
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("earning"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/earning`}
                          >
                            My Earnings
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("adworkshop"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/adworkshop`}
                          >
                            Ad workshop
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("orders"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/orders`}
                          >
                            My Orders
                          </Link>
                        </li>
                      </>
                    )}
                    {role === "brand" && (
                      <>
                        <li
                          className={clsx({
                            active: pathname.endsWith("/dashboard/brand"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/brand`}
                          >
                            My Account
                          </Link>
                        </li>

                        <li
                          className={clsx({
                            active: pathname.endsWith("adworkshop"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/adworkshop`}
                          >
                            Ad workshop
                          </Link>
                        </li>
                      </>
                    )}
                    {/**
                     * Uncomment later
                     */}
                    {role === "customer" && (
                      <>
                        <li
                          className={clsx({
                            active: pathname.endsWith("/dashboard/customer"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/customer`}
                          >
                            My Account
                          </Link>
                        </li>
                        <li
                          className={clsx({
                            active: pathname.endsWith("order"),
                          })}
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/order`}
                          >
                            My Orders
                          </Link>
                        </li>
                        {/* <li
												className={clsx({
													active: pathname.endsWith(
														"address-book"
													),
												})}>
												<Link
													to={`${
														process.env.PUBLIC_URL
													}/dashboard/${role}/address-book`}>
													Address Book
												</Link>
											</li> */}
                      </>
                    )}
                    <li
                          className={clsx({
                            active: pathname.endsWith("payment-method"),
                          })}
                        >
                          {/* <Link
                            to={`${process.env.PUBLIC_URL}/dashboard/${role}/payment-method`}
                          >
                            Change Method of Receiving Cash
                          </Link> */}
                           <Link to={`${process.env.PUBLIC_URL}/account-list`}>
                            Manage Accounts
                          </Link>
                        </li>
                    <h6
                      className="ml-4"
                      // {clsx({
                      //   active: pathname.endsWith('change-my'),
                      // })}
                    >
                      <Link
                        to="#"
                        // {`${process.env.PUBLIC_URL}/dashboard/${role}/change-my`}
                      >
                        Change My
                      </Link>
                    </h6>

                    <ul>
                      <li
                        className={`${clsx({
                          active: pathname.endsWith("change-password"),
                        })} ml-3`}
                      >
                        <Link
                          to={`${process.env.PUBLIC_URL}/dashboard/${role}/change-password`}
                        >
                          Password
                        </Link>
                      </li>
                      <li
                        className={`${clsx({
                          active: pathname.endsWith("change-password"),
                        })} ml-3`}
                      >
                        <Link
                          to={`${process.env.PUBLIC_URL}/dashboard/${role}/change-my`}
                        >
                          Account Details
                        </Link>
                      </li>
                      <li
                        className={clsx({
                          active: pathname.endsWith("contact"),
                        })}
                      >
                        <Link to={`${process.env.PUBLIC_URL}/contact`}>
                          Contact Admin
                        </Link>
                      </li>
                    </ul>

                    <li className="last">
                      <Link
                        to="#"
                        onClick={() => {
                          dispatch(auth_actions.logout());
                          history.replace("/");
                        }}
                      >
                        Log Out
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="dashboard-right">
                <Switch>
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/create-product/:product_id`}
                    component={CreateProduct}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/create-product`}
                    component={CreateProduct}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/greeting`}
                    component={addGreeting}
                  />

                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/add-charges`}
                    component={AddCharges}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/payment-method`}
                    component={changePaymentMethod}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/products`}
                    component={Products}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/order`}
                    component={Orders}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/earning`}
                    component={Earnings}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/address-book`}
                    component={AddressBook}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/change-password`}
                    component={ChangePassword}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/change-my`}
                    component={ChangeCredentials}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/my-contacts`}
                    component={MyContacts}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/merchant`}
                    component={AccountInfo}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/brand`}
                    component={AccountBrand}
                  />
                  {/* <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/eac`}
                    component={AvailableEac}
                  /> */}
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/customer`}
                    component={AccountBrand}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/account`}
                    component={AccountMember}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/account-history`}
                    component={AccountHistory}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/orders`}
                    component={OrdersMer}
                  />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/availableeac`}
                    component={Available}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/purchases`}
                    component={MemberPurchases}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/dashboard/${role}/adworkshop`}
                    component={MyAds}
                  />
                  {/* <Route
                    path={`${process.env.PUBLIC_URL}/contact`}
                    component={Contact}
                  /> */}
                  <Route />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
